import InputField from "../../../../reusable-components/TNInputField";
import {
  addContactModalFields,
  customStylingSelectField,
  notesField,
} from "./constants";
import styles from "./AddContactsForm.module.scss";
import CustomerDatabaseService from "../../../../services/customerDatabase.service";
import { toLabelValueArray } from "../../../../utils/getDropdownOptions";
import { useFormContext } from "react-hook-form";
import { addContactFields } from "../constants";
import { useCallback, useEffect } from "react";
import { formatPhoneNumber } from "../../../../utils/numberFormatterUtil";
import TNButton from "../../../../reusable-components/TNButton";
import {
  ButtonShape,
  ButtonSize,
  ButtonType,
} from "../../../../enums/ButtonAttributesEnums";
interface AddContactsFormProps {
  setContactRole?: () => void;
  handleOpenAddRole?: () => void;
}

const AddContactsForm = (props?: AddContactsFormProps) => {
  const { watch, setValue } = useFormContext();
  const { setContactRole, handleOpenAddRole } = props;
  const { FetchContactRoles } = CustomerDatabaseService();
  const { data } = FetchContactRoles({ isCrm: false });
  const options = toLabelValueArray(data?.data ?? []);
  const handlePhoneChange = useCallback((e) => {
    const formattedNumber = formatPhoneNumber(e);
    setValue("phone", formattedNumber);
  }, []);
  return (
    <>
      <div className={styles.TopSection}>
        {addContactModalFields.map((field) => (
          <InputField
            name={field.name}
            label={field.label}
            type={field.type}
            placeholder={field.placeholder}
            requiredField={field.required}
            {...(field.name === "roleId"
              ? {
                  dropdownSelectRender: (
                    <>
                      <TNButton
                        text={field.customButtonLabel}
                        type={ButtonType.PRIMARY}
                        size={ButtonSize.LARGE}
                        onClick={handleOpenAddRole}
                        customStyles={customStylingSelectField}
                        shape={ButtonShape.DEFAULT}
                      />
                    </>
                  ),
                  options: options,
                  allowClear: true,
                  onSelect: (val) => {
                    const contactRole = options?.find(
                      (option) => option?.value === val,
                    )?.label;
                    setContactRole(contactRole);
                    setValue("roleId", val);
                  },
                }
              : {})}
            {...(field.name === "phone"
              ? {
                  onChange: handlePhoneChange,
                }
              : {})}
          />
        ))}
      </div>
      <div>
        <InputField
          name={notesField.name}
          label={notesField.label}
          type={notesField.type}
          placeholder={notesField.placeholder}
        />
      </div>
    </>
  );
};

export default AddContactsForm;
